export enum GraphQueryTranslationKey {
    QUERIES = "query.menu.name",
    QUERIES_TITLE = "query.title",

    IDENTIFIER = "query.grid.id",
    NAME = "query.name",
    DESCRIPTION = "query.description",
    QUERY_TEXT = "query.query",
    TOOLTIP = "query.tooltip",
    ACCESS = "query.grid.permission",
    AUTHOR = "query.grid.author",
    CREATED = "query.grid.queryCreated",
    LAST_CHANGED = "query.grid.queryLastChanged",

    QUERY_RUN = "query.grid.icon.run",

    QUERIES_NOT_FETCHED = "query.notFetched",

    DELETE_FAILED = "query.delete.failed",
    DELETE_TITLE = "query.delete.title",
    DELETE_SUCCEEDED = "query.delete.succeeded",
    DELETE_QUESTION_MARK = "query.deleteQuestionMark",
    DELETE_CONSEQUENCE = "query.deleteConsequence",

    CREATE_TITLE = "query.create.title",
    DETAIL_TITLE = "query.detail.title",
    IS_PRIVATE = "query.isPrivate",
    UPDATE_SUCCEEDED = "query.updateSucceeded",
    ADD_SUCCEEDED = "query.addSucceeded",
    ADD_FAILED = "query.addFailed",

    EDITOR_RUN_QUERY = "query.editor.runQuery",
    EDITOR_TITLE = "query.editor.title",
    ERROR_QUERY_EXECUTION_MESSAGE = "query.executionError.message",
    ERROR_QUERY_EXECUTION_TITLE = "query.executionError.title",

    UNSAVED_CHANGES = "query.unsavedChanges",
    CONFIRMATION_TEXT = "query.discardChangesConfirmation",

    GRAPH = "query.graph",
    ELEMENTS = "query.elements",

    CYPHER_REF = "query.cypherRef",
    REFERENCE_ELEMENT = "query.referenceElement",

    GRAPH_MODEL_EXPORT_STARTED = "query.refreshingOfGraphModelStarted",
    REFRESH_GRAPH_MODEL = "query.refreshGraphModel",
    GRAPH_MODEL_WILL_BE_REFRESHED_FROM_MAIN_DATA_SOURCE = "query.graphModelWillBeRefreshedFromMainDataSource",
    REFRESH_GRAPH_MODEL_QUESTIONMARK = "query.refreshGraphModelQuestionmark",
    REFREH_GRAPH_MODEL_SUCCESS = "query.graphModelRefreshed",
}
